import type { FC } from 'react';

import type { MenuItemProps } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

// type Props = ty

const AtpMenuItem: FC<MenuItemProps> = (props) => {
  return <MenuItem {...props} />;
};

export default AtpMenuItem;
